/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Data_ProtectionInputs */

const de_commons_footer_data_protection = /** @type {(inputs: Commons_Footer_Data_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutz`)
};

/** @type {(inputs: Commons_Footer_Data_ProtectionInputs) => LocalizedString} */
const en_commons_footer_data_protection = de_commons_footer_data_protection;

/**

* @param {Commons_Footer_Data_ProtectionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_data_protection = /** @type {((inputs?: Commons_Footer_Data_ProtectionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Data_ProtectionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_data_protection(inputs)
	return en_commons_footer_data_protection(inputs)
});